import { IconName } from '@elearning-platform/ui';

import { RouteNameEnum } from '../enums';
import { MenuPosition } from '../interfaces';

export const menuPositions: MenuPosition[] = [
  {
    label: 'competence.app.menuPositions.dashboard.label',
    pathname: RouteNameEnum.Dashboard,
    icon: IconName.PageDashboard,
    renderOnStickyMobileMenu: true,
  },
  {
    label: 'competence.app.menuPositions.knowledgeBase.label',
    pathname: RouteNameEnum.KnowledgeBase,
    icon: IconName.PageKnowledgeBase,
    renderOnStickyMobileMenu: true,
  },
  {
    label: 'competence.app.menuPositions.idd.label',
    pathname: RouteNameEnum.Idd,
    icon: IconName.PageIdd,
  },
  {
    label: 'competence.app.menuPositions.trainings.label',
    pathname: RouteNameEnum.Trainings,
    icon: IconName.PageTrainings,
    renderOnStickyMobileMenu: true,
  },
  {
    label: 'competence.app.menuPositions.competences.label',
    pathname: RouteNameEnum.Competences,
    icon: IconName.PageCompetences,
  },
  {
    label: 'competence.app.menuPositions.gamificationInit.label',
    pathname: RouteNameEnum.GamificationInit,
    icon: IconName.PageGamification,
  },
  {
    label: 'competence.app.menuPositions.news.label',
    pathname: RouteNameEnum.News,
    icon: IconName.TriangleFilled,
  },
  {
    label: 'competence.app.menuPositions.onboarding.label',
    pathname: RouteNameEnum.Onboarding,
    icon: IconName.PageOnboarding,
  },
  {
    label: 'competence.app.menuPositions.teamIndicatorsStrategic.label',
    pathname: RouteNameEnum.TeamIndicatorsStrategic,
    icon: IconName.TriangleFilled,
  },
  {
    label: 'competence.app.menuPositions.certificates.label',
    pathname: RouteNameEnum.Certificates,
    icon: IconName.PageAchievements,
  },
  {
    label: 'competence.app.menuPositions.surveys.label',
    pathname: RouteNameEnum.Surveys,
    icon: IconName.PageFormsAndTests,
    renderOnStickyMobileMenu: true,
  },
  {
    label: 'toyota.app.menuPositions.provisions.label',
    pathname: RouteNameEnum.ProvisionsIntro,
    icon: IconName.PageCommisions,
  },
  {
    label: 'toyota.app.menuPositions.reports.label',
    pathname: RouteNameEnum.ReportsDashboard,
    icon: IconName.PageRaport,
  },
  {
    label: 'toyota.app.menuPositions.contracts.label',
    pathname: RouteNameEnum.Contracts,
    icon: IconName.PageDocuments,
  },
  {
    label: 'toyota.app.menuPositions.ofwcaCertificatePath.label',
    pathname: RouteNameEnum.OfwcaCertificatePath,
    icon: IconName.PageGamification,
  },
  {
    label: 'competence.app.menuPositions.usersAdministrationCompaniesList.label',
    pathname: RouteNameEnum.UsersAdministrationDashboard,
    icon: IconName.PageUsersAdministration,
  },
  {
    label: 'competence.app.menuPositions.substitutions.label',
    pathname: RouteNameEnum.SubstitutionsDashboard,
    icon: IconName.Substitutions,
  },
  {
    label: 'toyota.app.menuPositions.pathRequestsList.label',
    pathname: RouteNameEnum.PathRequestsList,
    icon: IconName.Tab,
  },
  {
    label: 'toyota.app.menuPositions.userPathRequests.label',
    pathname: RouteNameEnum.UserPathRequests,
    icon: IconName.Tab,
  },
];
